import { Select } from 'antd';
import React from 'react';

import { t } from '@System/i18n';
import { FINANCE_STATUS } from "@Modules/ImportPackage/services/constants";

const { Option } = Select;

export default function SelectFinanceStatuses(props) {
    return (
        <Select
            {...props}
            value={props.value || undefined}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {Object.keys(FINANCE_STATUS).map(opt => {
                return (
                    <Option key={FINANCE_STATUS[opt]} value={FINANCE_STATUS[opt]}>
                        {t(`product:FINANCE_STATUS.${FINANCE_STATUS[opt]}`)}
                    </Option>
                );
            })}
        </Select>
    );
}
